import { AVATARS_SUCCESS } from 'constants/actionTypes';

function avatarsReducer(state = {}, action) {
  switch (action.type) {
    case AVATARS_SUCCESS: {
      const avatars = action.payload;
      if (Object.keys(avatars).length) return { ...state, ...avatars };
      else return state;
    }
    default:
      return state;
  }
}

export default avatarsReducer;
